import $ from 'jquery';
import Rellax from 'rellax';
import { Component } from '../core/component';

export class HomeHeader extends Component {
    constructor() {
        super();
        this.selector = '.home-header';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            const homeRellax = new Rellax('.home-header__content', {
                speed: 1.4,
                center: false,
            });
            const homeMaskRellax = new Rellax('.home-header__mask-wrapper', {
                speed: 0.7,
                center: false,
            });
            if ($(window).width() <= 1030) {
                homeRellax.destroy();
                homeMaskRellax.destroy();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/home-header.js